import { render, staticRenderFns } from "./BTabs.vue?vue&type=template&id=318325cc&"
import script from "./BTabs.vue?vue&type=script&lang=js&"
export * from "./BTabs.vue?vue&type=script&lang=js&"
import style0 from "./BTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports